import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'employees': [],
  'employeesEvaluator': [],
  'employeesGestor': [],
  'employeesByCharge': [],
  'employeeSelected': null,
  'loading': false,
};

export const wtsEmployees = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_EMPLOYEES_GESTOR]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEES_GESTOR]: (state, action) => ({
      ...state,
      'loading': false,
      'employeesGestor': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEES_GESTOR_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'employeesGestor': [],
    }),
    [ActionTypes.FETCHING_WTS_EMPLOYEES_BY_CHARGE]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEES_BY_CHARGE]: (state, action) => ({
      ...state,
      'loading': false,
      'employeesByCharge': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEES_BY_CHARGE_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'employeesByCharge': [],
    }),
    [ActionTypes.FETCHING_WTS_EMPLOYEE_BY_ID]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_BY_ID]: (state, action) => ({
      ...state,
      'loading': false,
      'employeeSelected': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_BY_ID_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'employeeSelected': null,
    }),
    [ActionTypes.FETCHING_WTS_EMPLOYEE_BY_EMAIL]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_BY_EMAIL]: (state, action) => ({
      ...state,
      'loading': false,
      'employeeSelected': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_BY_EMAIL_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'employeeSelected': null,
    }),
    [ActionTypes.FETCHING_WTS_EMPLOYEES_EVALUATOR]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEES_EVALUATOR]: (state, action) => ({
      ...state,
      'loading': false,
      'employeesEvaluator': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEES_EVALUATOR_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'employeesEvaluator': [],
    }),
    [ActionTypes.CHANGE_WTS_EMPLOYEE_SELECTED]: (state, action) => ({
      ...state,
      'loading': false,
      'employeeSelected': action.payload,
    }),
    [ActionTypes.CREATING_WTS_EMPLOYEE]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATED_WTS_EMPLOYEE]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATED_WTS_EMPLOYEE_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_WTS_EMPLOYEE]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_WTS_EMPLOYEE]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_WTS_EMPLOYEE_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_WTS_EMPLOYEES_STATUS]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_WTS_EMPLOYEES_STATUS]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_WTS_EMPLOYEES_STATUS_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
